import React from 'react';
import PropTypes from 'prop-types';
import './LoadingComponent.scss';
import loadingIcon from '../images/loading.gif';

const LoadingComponent = ({ isLoading, loadingMessage }) =>
  isLoading && (
    <div
      className="loading-gif-container"
      aria-live="polite"
      aria-label="Loading"
    >
      <img src={loadingIcon} alt="loading" className="loading-gif-icon" />
      <div className="loading-message">{loadingMessage}</div>
    </div>
  );

LoadingComponent.propTypes = {
  isLoading: PropTypes.bool,
  loadingMessage: PropTypes.string,
};

export default LoadingComponent;
